import React, { useState } from 'react';

import { Button, FormControl, IconButton, InputLabel, MenuItem, Modal, Select, TextField } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import stylesMaterial from './stylesMaterial';
import { Container, Header } from './styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { OptionType } from '../../Historico';
import melhorEnvioService from '../../../services/melhorEnvio';
import { useToast } from '../../../hooks/toast';
import _ from 'lodash';

interface IPaymentOption { 
  value: string; 
  label: string; 
}

interface AddBalanceModalProps {
  open: boolean;
  handleClose: () => void;
  selectedBranch: OptionType;
}


export function AddBalanceModal({ open, handleClose, selectedBranch }: AddBalanceModalProps) {
  const classes = stylesMaterial();

  const { addToast } = useToast();
  const methods = [
    {
      value: 'moip',
      label: 'Moip'
    },
    {
      value: 'mercado-pago',
      label: 'Mercado Pago'
    },
    {
      value: 'picpay',
      label: 'PicPay'
    },
    {
      value: 'pagseguro',
      label: 'PagSeguro'
    }
  ];

  const [paymentMethod, setPaymentMethod] = useState<IPaymentOption | null>(null);
  const [value, setValue] = useState('');

  function handleAddBalance() {
    const valueTreated = value.replace(',', '.');
    melhorEnvioService.addBalance(paymentMethod?.value || '', valueTreated, selectedBranch.id).then((res) => {
      window.open(res.url);
      handleClose();
    }).catch((error) => {
      if(error.response && error.response.data){
        addToast({
          title: error.response.data.message,
          type: 'error',
        });
      } else {
        addToast({
          title: 'Ocorreu um erro na adição de saldo',
          type: 'error',
        });
      }
    });
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="add-balance-modal"
      aria-describedby="add-balance"
      className={classes.modal}
    >
      <Container>
        <Header>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className={classes.buttonClose}
          >
            <CloseIcon className={classes.iconClose} />
          </IconButton>
        </Header>

        <FormControl className={classes.formControl}>
          <Autocomplete
            value={paymentMethod}
            getOptionLabel={(option) => option.label}
            onChange={(event: any, newValue: IPaymentOption | null) => {
              if (newValue !== null){
                setPaymentMethod(newValue);
              }
            }}
            getOptionSelected = {(option,value) => _.isEqual(option,value)}
            id="payment-methods"
            options={methods}
            style={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Meio de pagamento" variant="outlined" />}
          />

          <TextField 
            id="value" 
            label="Valor" 
            variant="outlined" 
            value={value}
            onChange={(event) => setValue(event.target.value)}
            style={{ width: 300 }}
          />

          <Button
            onClick={handleAddBalance}
            className={classes.button}
          >
            Adicionar
          </Button>
        </FormControl>
      </Container>
    </Modal>
  );
}